import React, { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import axios from "../../../../axios/index";
import { Link } from "react-router-dom";

// styles
import Dstyles from "../../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";
import styles from "./AllBlogs.module.css";

// components
import HomeNavbar from "./../../HomeNavbar/HomeNavbar";
import Footer from "../../Footer/Footer";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import CustomPagination from "../../../CustomPagination/CustomPagination";

const AllBlogs = () => {
  const e2p = s => s?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
  const [page, setPage] = useState({
    pageNUmber: 1,
    pageCount: 1,
  });
  const [blogsData, setBlogsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useMemo(() => blogsData, [blogsData]);

  useEffect(() => {
    const getData = async () => {
      const getApiData = await axios.get("Article/GetArticles");
      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: getApiData.data.data.pageCount };
      });
      setBlogsData(getApiData.data.data.data);
      setIsLoading(false);
    };
    getData();
  }, []);

  return (
    <>
      <Helmet>
        <title>وبلاگ | آذر ملک</title>
        <meta name="description" content="وبلاگ آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
        <meta
          name="keywords"
          content="اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز, اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز"
        />
        <meta content="index , follow" name="robots" />
        <meta name="og:title" content="وبلاگ آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
        <meta name="description" content="وبلاگ آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
        <meta name="og:description" content="وبلاگ آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
        <meta rel="canonical" href="https://azrmelk.com/وبلاگ" />
        <meta content="website" property="og:type" />
        <meta content="https://azrmelk.com" name="twitter:site" />
        <meta content="https://azrmelk.com/وبلاگ" property="og:url" />
      </Helmet>
      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar blogs />
            <section className="container py-3 px-0">
              <div className="w-100 d-flex justify-content-start flex-wrap align-items-center mt-3 px-md-2 px-3 " dir="rtl">
                <div className="d-flex align-items-center justify-content-center mt-2 mb-2">
                  <h1 className={styles.title}>بلاگ</h1>
                </div>

                <div className="w-100 d-flex align-items-start justify-content-center my-3 flex-wrap text-end">
                  {blogsData[0] && (
                    <div className={`d-flex flex-column align-items-center justify-content-start p-2 ms-md-4 ms-0 my-md-0 my-3 ${styles.card_lg}`}>
                      <Link
                        className="w-100"
                        to={{
                          pathname: `/وبلاگ/${blogsData[0]?.slug}`,
                          state: blogsData[0],
                        }}>
                        <img
                          className={`w-100 ${styles.card_img}`}
                          src={`https://backdev.azrmelk.com/magAssets/img/Articles/${blogsData[0]?.imageName}`}
                          alt={blogsData[0]?.title}
                          loading="lazy"
                        />
                      </Link>
                      <div className="w-100 d-flex flex-column align-items-start justify-content-center flex-wrap mt-3">
                        <Link
                          to={{
                            pathname: `/وبلاگ/${blogsData[0]?.slug}`,
                            state: blogsData[0],
                          }}
                          className={styles.card_title}>
                          {blogsData[0]?.title}
                        </Link>
                        {/* <div className={`my-2 ${styles.card_pretext}`}>
                                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                                    </div> */}
                        <div className="d-flex align-items-center justify-content-center my-2">
                          <div className={styles.blog_bottom_text}>{blogsData[0]?.ownerName}</div>
                          <div className={`mx-3 ${styles.rounded}`}></div>
                          <div className={styles.blog_bottom_text}>{blogsData[0]?.dateRelease.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="d-flex flex-column align-items-center justify-content-center me-md-4 me-0">
                    {blogsData[1] && (
                      <div className={`d-flex flex-md-row flex-column align-items-center justify-content-start p-2 mt-md-0 mb-md-2 my-3 ${styles.card_sm}`}>
                        <Link
                          className={`ms-md-3 ms-0 ${styles.card_img_sm}`}
                          to={{
                            pathname: `/وبلاگ/${blogsData[1]?.slug}`,
                            state: blogsData[1],
                          }}>
                          <img
                            className={`${styles.card_img_sm}`}
                            src={`https://backdev.azrmelk.com/magAssets/img/Articles/${blogsData[1]?.imageName}`}
                            alt={blogsData[1]?.title}
                            loading="lazy"
                          />
                        </Link>
                        <div className="w-100 d-flex flex-column align-items-start justify-content-center flex-wrap mt-3">
                          <Link
                            to={{
                              pathname: `/وبلاگ/${blogsData[1]?.slug}`,
                              state: blogsData[1],
                            }}
                            className={styles.card_title}>
                            {blogsData[1]?.title}
                          </Link>
                          {/* <div className={`my-2 ${styles.card_pretext}`}>
                                                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                                        </div> */}
                          <div className="d-flex align-items-center justify-content-center my-2">
                            <div className={styles.blog_bottom_text}>{blogsData[1]?.ownerName}</div>
                            <div className={`mx-3 ${styles.rounded}`}></div>
                            <div className={styles.blog_bottom_text}>{blogsData[1]?.dateRelease.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                          </div>
                        </div>
                      </div>
                    )}

                    {blogsData[2] && (
                      <div className={`d-flex flex-md-row flex-column align-items-center justify-content-start p-2 my-md-2 my-3 ${styles.card_sm}`}>
                        <Link
                          className={`ms-md-3 ms-0 ${styles.card_img_sm}`}
                          to={{
                            pathname: `/وبلاگ/${blogsData[2]?.slug}`,
                            state: blogsData[2],
                          }}>
                          <img
                            className={`${styles.card_img_sm}`}
                            src={`https://backdev.azrmelk.com/magAssets/img/Articles/${blogsData[2]?.imageName}`}
                            alt={blogsData[2]?.title}
                            loading="lazy"
                          />
                        </Link>
                        <div className="w-100 d-flex flex-column align-items-start justify-content-center flex-wrap mt-3">
                          <Link
                            to={{
                              pathname: `/وبلاگ/${blogsData[2]?.slug}`,
                              state: blogsData[2],
                            }}
                            className={styles.card_title}>
                            {blogsData[2]?.title}
                          </Link>
                          {/* <div className={`my-2 ${styles.card_pretext}`}>
                                                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                                        </div> */}
                          <div className="d-flex align-items-center justify-content-center my-2">
                            <div className={styles.blog_bottom_text}>{blogsData[2]?.ownerName}</div>
                            <div className={`mx-3 ${styles.rounded}`}></div>
                            <div className={styles.blog_bottom_text}>{blogsData[2]?.dateRelease.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="w-100 d-flex align-items-center justify-content-between my-3 flex-wrap text-end">
                  {blogsData?.map(item => (
                    <div key={item.id} className={`d-flex flex-column align-items-center justify-content-start p-2 my-3 text-end ${styles.card}`}>
                      <Link
                        to={{
                          pathname: `/وبلاگ/${item.slug}`,
                          state: item,
                        }}>
                        <img
                          className={`w-100 ${styles.card_img}`}
                          src={`https://backdev.azrmelk.com/magAssets/img/Articles/${item.imageName}`}
                          alt={item.title}
                          loading="lazy"
                        />
                      </Link>
                      <div className="w-100 d-flex flex-column align-items-start justify-content-center flex-wrap mt-3">
                        <Link
                          to={{
                            pathname: `/وبلاگ/${item.slug}`,
                            state: item,
                          }}>
                          <h2 className={styles.card_title}>{item.title}</h2>
                        </Link>
                        {/* <div className={`my-2 ${styles.card_pretext}`}>
                                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                                    </div> */}
                        <div className="d-flex align-items-center justify-content-center my-2">
                          <div className={styles.blog_bottom_text}>{item.ownerName}</div>
                          <div className={`mx-3 ${styles.rounded}`}></div>
                          <div className={styles.blog_bottom_text}>{e2p(item.dateRelease)}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
            <Stack
              className={Dstyles.pagination}
              spacing={1}
              sx={{
                direction: "ltr",
                bottom: "0",
                height: "85px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center !important",
              }}>
              {/* <Typography>Page: {page}</Typography> */}
              <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNUmber} onChange={paginationHandler} />
            </Stack>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getApiData = await axios.get(`Article/GetArticles?PageId=${value}`);
    setPage(prev => {
      return { ...prev, pageCount: getApiData.data.data.pageCount, pageNumber: value };
    });
    setBlogsData(getApiData.data.data.data);
    setIsLoading(false);
  }
};

export default AllBlogs;
